<template>
	<transition name="modal">
		<div
			class="modal-mask"
			:class="`modal-type-${type}`">
			<div class="modal-wrapper has-scroll" @click.self="$emit('close')">
				<div class="modal-container">
					<slot name="body"></slot>
				</div>
			</div>
		</div>
	</transition>
</template>

<script>
export default {
	name: 'Modal',
	props: {
		type: {
			type: String,
			default: 'popup', // popup, lightbox
		},
	},
	methods: {
		onKeyup(event) {
			if (event.key === 'Escape') {
				this.$emit('close');
			}
		},
	},
	created() {
		document.body.classList.add('modal-open');
		window.addEventListener('keyup', this.onKeyup);
	},
	destroyed() {
		document.body.classList.remove('modal-open');
		window.removeEventListener('keyup', this.onKeyup);
	},
};
</script>

<style scoped>
.modal-container {
	@media (min-width: 575px) {
		width: fit-content;
	}
}
</style>
